import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import World from "@frog/source/models/World.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Travel from "@frog/source/data/games/ember/travel.js"

import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Objdict from "objdict"

// window.addEventListener("click", (event) => {
//     const dom = document.getElementById("frame")
//     const box = dom.getBoundingClientRect()
//     const x = (((event.clientX - box.x) / box.width) * 16).toFixed(2)
//     const y = (((event.clientY - box.y) / box.height) * 9).toFixed(2)
//     console.log(x, y)
// })

export default {
    "slug": "3",
    "decorations": {
        "hasSnow": true,
    },
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "text": function(stage) {
            if(stage?.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }
            // if(stage.flags["tutorial:hasRallied"] != true) {
            //     return (
            //         <div class="TutorialPrompt" position="topright">
            //             <div class="Text">
            //                 The firekeeper has the power to RALLY her friends,
            //                 allowing them to act twice in a turn.
            //             </div>
            //         </div>
            //     )
            // }
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    // Step.flag("hud", "hidden"),
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "goodspawn"}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    function(stage) {
                        let steps = []

                        const encounterKeys = [1]
                        encounterKeys.forEach((encounterKey, index) => {
                            const spots = Random.shuffle(Object.values(stage.world.spots).filter((spot) => {
                                return Zone.isInBounds(stage.encounters[encounterKey], spot.position)
                                    && spot.tag == "badspawn"
                            }))

                            if(spots.length == 0) return

                            const unitCount = Math.max(4, index + 1)

                            for(let i = 0; i < unitCount; i += 1) {
                                const spot = spots[i]
                                if(spot == undefined) return
                                steps.push(Step.deltastage({
                                    "unit": {
                                        "affiliation": "bad",
                                        "title": "???",
                                        "subtitle": "Monstrosity",
                                        "jobKey": Random.element(["sword", "spear", "hammer", "dagger", "bow"]),
                                        "health": 25,
                                        "maxhealth": 30,
                                        "position": {
                                            "x": spot.position.x,
                                            "y": spot.position.y,
                                            "z": spot.position.z,
                                        },
                                    }
                                }))
                            }
                        })

                        return steps
                    },
                ]
            },
            {
                "type": "turn:every:end",
                "events": [
                    PlotSteps.SlowDeath(),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation
                        })
                },
                "events": [
                    PlotSteps.SlowDeath(),
                    PlotSteps.ChapterSuccess(),
                    PlotSteps.PlayAudio("Ember:Music:Wander"),
                    PlotSteps.HealPlayerPartyScript({"percent": 0}),
                    {"func": () => Navigation.go("/games/ember/campfire")},
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.ChapterFailure(),
                    Step.flag("modal", "blackscreen"),
                    "And thus the fire dies.",
                    {"func": () => App.game.chapter.restart()},
                ]
            },
        ]
    },
}
